<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'eventComments.commentsTitle' | t }}</div>
    <div class="detail-page-card-body">
        @if (isLoading) {
            <div class="fancy-loader submodule my-4"></div>
        } @else {
            <div>
                @if (comments && comments.length > 0) {
                    <div class="comments">
                        <div class="row headers">
                            <div class="col-5">{{ 'eventComments.columnComment' | t }}</div>
                            <div class="col">{{ 'eventComments.columnType' | t }}</div>
                            <div class="col">{{ 'eventComments.columnUser' | t }}</div>
                            <div class="col">{{ 'eventComments.columnDate' | t }}</div>
                        </div>

                        @for (comment of scopedComments; track comment) {
                            <div
                                class="row comment-row"
                                [class.comment-deleted]="comment.isDeleted"
                            >
                                <div class="col-5">
                                    @if (comment.comment) {
                                        <span>{{ comment.comment }}</span>
                                    } @else {
                                        <i style="font-size: 0.8em">{{ 'eventComments.noCommentGiven' | t }}</i>
                                    }
                                </div>
                                <div class="col">{{ comment.commentType }}</div>
                                <div class="col">{{ comment.createdBy }}</div>
                                <div class="col">{{ comment.createdAt | dateFormat }}</div>
                            </div>
                        }
                    </div>
                    @if (comments.length > 5) {
                        <div class="more-comments" (click)="showAllClick(!showAll)">
                            {{ (showAll ? ('eventComments.viewLastFive' | t) : ('eventComments.viewAll' | t : { count: comments.length })) }}
                        </div>
                    }
                } @else {
                    <div class="no-comments">{{ 'eventComments.noCommentsAvailable' | t }}</div>
                }
            </div>
        }
    </div>
</div>
